import React from 'react';
import {json} from "helpers/data";
import {useTranslation} from "react-i18next";

interface Props {
    content: string;
}

function DescriptionBox({content}: Props) {
    const {t} =  useTranslation();
    const [fullDes,setFullDes] = React.useState(false)
    function handleShowFull() {
        setFullDes(!fullDes)
    }


    return (
        <div className='description'>
            <h1 className='title'>{t('details:addonDetails.description')} </h1>

            <div className={fullDes ? 'full-info' : 'info'}  dangerouslySetInnerHTML={{ __html: json(content) }}></div>

            <span onClick={handleShowFull} className='full'>{fullDes ? t('details:addonDetails.viewLess') : t('details:addonDetails.viewFull')}</span>

        </div>
    );
}

export default DescriptionBox;